module.exports = function getResource(label, vars = []) {
    const resources = {
        previewSettings: 'Aperçu des réglages',
        showAssets: 'Afficher les actifs',
        active: 'Actif',
        all: 'Tous',
        viewOnActualInventory: 'Voir selon l’inventaire réel',
        viewAsInStock: 'Voir les produits en stock (ignorer l’inventaire)',
        go: 'Recherche'
    };
    return resources[label];
};
